import { int } from '../lib/int.js'
export class Upload {
    constructor(form = ui.select('#upload_form')) {
        if(window.upload) return
        window.upload = this

        this.form = form
        if(!form) return
        this.fileInput = form.querySelector('input[type="file"]')
        this.uploadButton = this.form.querySelector('button[type="submit"]')

        if(ui.element('upload_form',false)){
            this.selectFiles()
            this.uploadButton.addEventListener('click',event => {
                event.preventDefault()
                let file_size = 0
                let total_size = 0
                for (let i = 0; i < this.fileInput.files.length; i++) {
                    file_size = this.fileInput.files[i].size
                    total_size += file_size
                }
                console.log('Total upload size', total_size)
                let finished = []
                for (let i = 0; i < this.fileInput.files.length; i++) {
                    finished[i] = false
                    console.log('i =', i, ' Uploaded:', finished[i])
                    this.fileUpload(i,this.fileInput.files.length, finished, total_size)
                }
            })
        }
    }

    fileUpload(i = 0,total = this.fileInput.files.length, finished, total_size){
        console.log(this.fileInput.files)
        const upload_form = this.form,
              upload_button = this.uploadButton,
              file_input = upload_form.querySelector('input[type="file"]'),
              formData = new FormData(),
              request = new XMLHttpRequest(),
              progressBar = ui.element('div', { class : 'progress-bar bg-secondary', role : 'progressbar', 'aria-valuenow' : 0, 'aria-valuemin' : 0, 'aria-valuemax' : 100 }),
              progress = ui.element('div',{ class : 'progress'}, progressBar)

                formData.append(this.fileInput.name, this.fileInput.files[i])
                formData.append('_token', ui.token)
                ui.select('#file_description_'+i).append(progress)
                request.upload.addEventListener( 'progress', event => {
                    const fileSize = file_input.files[0].size
                    if(event.loaded <= fileSize){
                        const  percent = Math.round(event.loaded / fileSize * 100 )
                        progressBar.style.width = `${percent}%`
                        progressBar.setAttribute('aria-valuenow', percent)
                        progressBar.textContent = `${percent}%`
                        //ui.select('.modal-title span').textContent = __('Upload File') + ' ' +percent+'%'
                    }
                    if(event.loaded === event.total){
                        progressBar.style.width = '100%'
                        progressBar.setAttribute('aria-valuenow', 100)
                        progressBar.textContent = '100%'
                        finished[i] = true
                        console.log('i =', i, ' Uploaded:', finished[i])
                        //ui.select('.modal-title span').textContent =  __('Upload File') + ' 100%'
                    }
                })
                request.upload.addEventListener( 'loadend', event => {
                    console.log(request, event)
                    // if(request.status === 200){
                    //     modal_body.prepend(ui.element('div',{ class : 'alert alert-success', role : 'alert'},'<i class="fas fa-check"></i> <b>'+file_input.files[i].name+'</b> has been succesfully uploaded'))
                    // }else{
                    //     modal_body.prepend(ui.element('div',{ class : 'alert alert-danger', role : 'alert'},'<i class="fa-duotone fa-triangle-exclamation"></i> An error occured while uploading <b>'+file_input.files[i].name+'</b> ('+request.statusText+')'))
                    // }

                    if(!finished.includes(false)){
                        console.log(total, 'files uploaded!')
                        console.log('Total size', total_size)
                        // Set delay for file handling, depending on total upload size before returning to content index
                        const delay = 1000 + Math.round(total_size/100000)
                        console.log('Delay', delay, 'ms')
                        setTimeout(()=> {
                        //     //playlist.loadContentTable(dir)
                        //     //ui.select('.alert-succes').remove()
                        //     //ui.select('.modal-title span').textContent = __('Select File')
                            if(this.form.dataset.folderId === this.form.dataset.rootFolderId)
                                window.location.replace('/content/')
                            else
                                window.location.replace(`/content/folder/${this.form.dataset.folderId}`)
                        },delay)
                    }
                })
                request.open('post', this.form.action)
                request.send(formData)
            }

    selectFiles(){
        const img_preview = ui.element('img',{class : 'd-none preview'}),
        video_preview = ui.element('video',{class : 'd-none preview'}, ui.element('source'))
                        
        upload.fileInput.addEventListener('change',event => {

            if(event.target.files.length) {
               //upload_form.classList.add('d-none')
               ui.select('.preview')?.remove()
                const file_types = ui.select('[data-content-types]').dataset.contentTypes.split(',')//,
                //file_mime_types = file_types.map(type => type.name)
                //event.target.files.forEach(file =>{

                for (let i = 0; i < event.target.files.length; i++) {
                    let file = event.target.files[i]
                    console.log('File type: ' + file.type)
                    if(ui.select('#file_description_'+i)) ui.select('#file_description_'+i).remove()
                    const description = ui.element('div',{id : 'file_description_'+i, class : 'lead', style : 'margin-left: 25px; cursor:pointer;'} )

                    if(file.type.startsWith('image')){
                        this.form.prepend(img_preview)
                        img_preview.style = 'width:100%;border-radius:5px;'
                        img_preview.src = URL.createObjectURL(file)

                        // Set time delay to load image resolution.
                        // When multiple images are selected, the resolution of the last image will be set for allmimages,
                        // due to asynchronus behaviour. This still has to be worked out.
                        setTimeout(()=>{
                            var width = img_preview.naturalWidth
                            var height = img_preview.naturalHeight
                            description.innerHTML = '<i class="fa-duotone fa-photo-film" alt="Folders"></i> ' + file.name + ' | ' + file.type + ' | '+  img_preview.naturalWidth + 'x' + img_preview.naturalHeight + ' | ' + int.formatBytes(file.size)
                            description.addEventListener('click',()=>{
                                ui.select(':.preview').forEach(preview => preview.classList.add('d-none'))
                                img_preview.classList.remove('d-none')
                                img_preview.src = URL.createObjectURL(file)
                            })
                            console.log('Width: ' + width, 'Height: ' + height)
                            if ((width > 3840 || height > 3840)) { // Extra validation added on image resolution to prevent system php crash (issue 280)
                                this.uploadButton.disabled = true
                                description.append(ui.element('div',{ class : 'text-danger', role : 'alert'},'<i class="fa-duotone fa-triangle-exclamation"></i> '+__('Resolution')+' '+__('of')+' '+__('Image')+' '+__('is too high')+' ('+__('maximum')+' 3840x2160)'))
                                event.target.classList.remove('d-none')
                            }
                            if (file.size > 5242880) {
                                this.uploadButton.disabled = true
                                description.append(ui.element('div',{ class : 'text-danger', role : 'alert'},'<i class="fa-duotone fa-triangle-exclamation"></i> '+__('Image')+' '+__('is too large')+' ('+__('maximum')+' '+int.formatBytes(5242880)+')'))
                                event.target.classList.remove('d-none')
                               }
                        },500)

                    }else if(file.type.startsWith('video')){
                        video_preview.style = 'width:100%;border-radius:5px;'
                        video_preview.controls = true
                        const video_preview_ = video_preview.cloneNode(true)

                        video_preview_.querySelector('source').src = URL.createObjectURL(file)
                        video_preview_.setAttribute('id','video_'+i)
                        video_preview_.classList.add('d-none')
                        this.form.prepend( video_preview_)
                        description.innerHTML = '<i class="fa-duotone fa-photo-film" alt="Folders"></i> ' + file.name + ' | ' + file.type + ' | ' + int.formatBytes(file.size)
                        description.addEventListener('click',()=>{
                            ui.select(':.preview').forEach(preview => preview.classList.add('d-none'))
                            video_preview_.classList.remove('d-none')
                        })
                    }

                    this.form.prepend(description)
                    this.uploadButton.disabled = false
                    if(!file_types.includes(file.type)){
                        this.uploadButton.disabled = true
                        description.append(ui.element('div',{ class : 'text-danger', role : 'alert'},'<i class="fa-duotone fa-triangle-exclamation"></i> '+__('File type')+' <b>'+file.type.substring(file.type.indexOf('/')+1)+'</b> '+__('is not supported')))
                        event.target.classList.remove('d-none')
                    }
                    if(file.size > ui.select('[data-upload-max-size]').dataset.uploadMaxSize){
                        this.uploadButton.disabled = true
                        description.append(ui.element('div',{ class : 'text-danger', role : 'alert'},'<i class="fa-duotone fa-triangle-exclamation"></i> '+__('File')+' '+__('is too large')+' ('+__('maximum')+' '+int.formatBytes(1073741824)+')'))
                        event.target.classList.remove('d-none')
                    }
                }

                if(event.target.files.length == 1){
                    ui.select(':.preview')[0].classList.remove('d-none')
                }                                                
            }
        })
    }
}
